    package org.example.zone360.pages.dashboard.clubKeywords

    import androidx.compose.runtime.Composable
    import androidx.compose.runtime.remember
    import com.varabyte.kobweb.compose.foundation.layout.Box
    import com.varabyte.kobweb.compose.ui.Alignment
    import com.varabyte.kobweb.compose.ui.Modifier
    import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
    import com.varabyte.kobweb.compose.ui.modifiers.border
    import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
    import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
    import com.varabyte.kobweb.compose.ui.modifiers.fontSize
    import com.varabyte.kobweb.compose.ui.modifiers.height
    import com.varabyte.kobweb.compose.ui.modifiers.margin
    import com.varabyte.kobweb.compose.ui.modifiers.padding
    import com.varabyte.kobweb.silk.components.text.SpanText
    import com.varabyte.kobweb.silk.theme.colors.ColorMode
    import org.example.zone360.models.CustomKeywordsData
    import org.example.zone360.theme.toSitePalette
    import org.example.zone360.utils.Constants
    import org.example.zone360.utils.SelectedLanguage
    import org.jetbrains.compose.web.css.LineStyle
    import org.jetbrains.compose.web.css.px

    @Composable
    fun KeywordsWithoutCount(
        response: List<CustomKeywordsData>,
        selectedLanguage: SelectedLanguage,
    ) {
        val sitePalette = ColorMode.current.toSitePalette()
        val shuffledList = remember(response) { response.shuffled() }
        shuffledList.forEach { keywordData ->
            val keywordText = keywordData.text
            val keywordCategory = keywordData.keywordCategory
            Box {
                Box(
                    modifier = Modifier.height(32.px)
                        .backgroundColor(
                            when (keywordCategory) {
                                if (selectedLanguage == SelectedLanguage.English) "fitness" else "atletico" -> sitePalette.fitnessCategoryBackground.rgb
                                if (selectedLanguage == SelectedLanguage.English) "mental" else "mentale" -> sitePalette.mentalCategoryBackground.rgb
                                if (selectedLanguage == SelectedLanguage.English) "technical" else "tecnica" -> sitePalette.technicalCategoryBackground.rgb
                                if (selectedLanguage == SelectedLanguage.English) "tactical" else "tattica" -> sitePalette.tacticalCategoryBackground.rgb
                                if (selectedLanguage == SelectedLanguage.English) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBackground.rgb
                                else -> sitePalette.primary.rgb.copyf(alpha = 0.1f)
                            }
                        )
                        .borderRadius(7.px)
                        .padding(leftRight = 8.px, topBottom = 4.px)
                        .border(
                            1.px, color =
                            when (keywordCategory) {
                                if (selectedLanguage == SelectedLanguage.English) "fitness" else "atletico" -> sitePalette.fitnessCategoryBorder.rgb
                                if (selectedLanguage == SelectedLanguage.English) "mental" else "mentale" -> sitePalette.mentalCategoryBorder.rgb
                                if (selectedLanguage == SelectedLanguage.English) "technical" else "tecnica" -> sitePalette.technicalCategoryBorder.rgb
                                if (selectedLanguage == SelectedLanguage.English) "tactical" else "tattica" -> sitePalette.tacticalCategoryBorder.rgb
                                if (selectedLanguage == SelectedLanguage.English) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBorder.rgb
                                else -> sitePalette.primary.rgb
                            }, style = LineStyle.Solid
                        )
                        .margin(7.px),
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        keywordText,
                        modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontSize(13.px)
                    )
                }
            }
        }
    }
